import * as React from "react";

function FilePdfIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m365.3 93.38-74.63-74.64C278.6 6.742 262.3 0 245.4 0H64C28.65 0 0 28.65 0 64l.006 384c0 35.34 28.65 64 64 64H320c35.2 0 64-28.8 64-64V138.6c0-16.9-6.7-33.2-18.7-45.22zM336 448c0 8.836-7.164 16-16 16H64.02c-8.838 0-16-7.164-16-16L48 64.13c0-8.836 7.164-16 16-16h160V128c0 17.67 14.33 32 32 32h79.1v288zM202 286.1c.877-2.688 1.74-5.398 2.582-8.145 1.434-5.762 7.488-31.54 7.488-52.47C212.1 207 197.1 192 178.6 192s-33.5 15-33.5 33.5c0 .297.164 28.81 13.85 62.3-7.035 19.36-15.57 38.8-25.41 57.93-21.49 10.11-39.24 22.23-52.8 36.07-6.234 6.438-9.367 14.74-9.367 24.72 0 18.45 15.01 33.46 33.46 33.46 10.8 0 20.98-5.227 27.22-13.98 7.322-10.28 18.38-26.9 30.47-48.95 15.8-6.352 33.88-11.72 53.88-16 13.55 9.578 28.9 17.29 45.71 22.95 4.527 1.551 9.402 2.348 14.43 2.348 20.26 0 36.13-16.19 36.13-36.86 0-20.33-16.54-36.87-36.87-36.87h-3.705c-2.727.125-20.51 1.141-45.37 5.367C216.9 308.9 208.6 298.3 202 286.1zm-91.8 124.3c-3.273 4.688-12.03 2.777-12.03-5.312 0-1.754.629-3.43 1.729-4.555 9.02-9.219 19.94-17.05 31.85-23.72C122.3 393.1 114.3 404.7 110.2 410.4zm68.4-191.6c3.693 0 6.703 3.008 6.703 6.703 0 15.21-4.109 34.84-5.746 42.1C172.1 245 171.9 227.2 171.9 225.5c0-3.7 3-6.7 6.7-6.7zm-16.3 129.5a523.013 523.013 0 0 0 19.38-44.7c6.389 10.92 14.56 21.86 24.96 31.97-14.04 3.23-29.24 7.33-44.34 12.73zm110.1-8.8h3.352c5.539 0 10.05 4.5 10.05 10.79 0 5.129-4.176 9.32-9.32 9.32-2.029 0-4.059-.316-5.852-.941-12.33-4.137-23.11-9.32-32.54-15.19 20.21-3.179 34.01-3.979 34.31-3.979z"
  }));
}

const ForwardRef = React.forwardRef(FilePdfIcon);
export default ForwardRef;